var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('infinite-autocomplete', {
    key: _vm.key,
    ref: "search",
    attrs: {
      "input-id": _vm.inputId,
      "disabled": _vm.disabled,
      "items": _vm.allItems,
      "loading": _vm.loading,
      "hasMore": _vm.hasMore,
      "item-text": _vm.itemText,
      "label": _vm.labelText,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "autofocus": _vm.autofocus,
      "readonly": _vm.readonly,
      "hide-details": _vm.hideDetails,
      "dense": _vm.dense,
      "clearable": _vm.isClearable,
      "selected-key": _vm.selectedKey,
      "active-item": _vm.activeItem,
      "outlined": _vm.outlined,
      "flat": _vm.flat,
      "background-color": _vm.backgroundColor,
      "icon": _vm.icon,
      "error-messages": _vm.errorMessages,
      "menu-props": _vm.menuProps,
      "select-mode": _vm.selectMode
    },
    on: {
      "menu-opened": _vm.onMenuOpened,
      "search-changed": _vm.onSearchChanged,
      "load-more": _vm.loadNextPage,
      "select": function select($event) {
        return _vm.$emit('select', $event);
      },
      "input": _vm.inputChanged
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref) {
        var item = _ref.item;
        return _vm.$scopedSlots.selection ? [_vm._t("selection", null, {
          "item": item
        })] : undefined;
      }
    }, {
      key: "item",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._t("item", function () {
          return [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.itemText(item)) + " ")])];
        }, {
          "item": item
        })];
      }
    }, {
      key: "active-item",
      fn: function fn(_ref3) {
        var activeItem = _ref3.activeItem;
        return [_c('div', {
          staticClass: "active"
        }, [_vm._t("item", function () {
          return [_vm._v(" " + _vm._s(_vm.itemText(activeItem)) + " ")];
        }, {
          "item": activeItem
        })], 2)];
      }
    }], null, true),
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }